// extracted by mini-css-extract-plugin
export var addressFields = "_oy-0";
export var animationContainer = "_oy-1";
export var footer = "_oy-2";
export var lineItems = "_oy-3";
export var modalContent = "_oy-4";
export var orderName = "_oy-5";
export var strong = "_oy-6";
export var warning = "_oy-7";